import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class Customer extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'customer',
            id: this.props.Id,      
            loading: true,
            lockScreen: 0,
            data: null,
            users: [],               
            record: {
                id: 0,
                type: 1,         
                name: '',
                nationalId: '',
                economicCode: '',
                phone: '',
                address: '',
                managerUserId: null,
                supervisorUserId: null,
                status: 1        
            },

            activeTab: 'info',    
            notes: [],
            newNote: '',
            newNoteType: 1,        
            loadingNotes: false
        };
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        const currentId = this.getCurrentFormId();
        this.httpPost(`api/v1/${this.state.controllerName}/get`, { id: currentId })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        record: data.record,
                        users: data.users,
                        loading: false,
                        data:data
                    });
     
                    if (currentId > 0) {
                        this.loadNotes(currentId);
                    }
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loading: false });
                }
            });
    }

    handleChange(field, value) {
        const record = { ...this.state.record };
        record[field] = value;
        this.setState({ record });
    }

    async save(e) {
        e.preventDefault();
        this.setState({ lockScreen: 1 });

        this.httpPost(`api/v1/${this.state.controllerName}/save`, this.state.record)
            .then(data => {
                this.setState({ lockScreen: 0 });
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage('اطلاعات مشتری با موفقیت ذخیره شد');
                    this.setState({ redirect: '/customers' });
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    loadNotes(customerId) {
        const cId = customerId || this.getCurrentFormId();
        if (!cId || cId === 0) return;
        this.setState({ loadingNotes: true });
        this.httpPost('api/v1/customernote/list', { customerId: cId })
            .then(data => {
                if (data.status === 1) {
                    this.setState({ notes: data.records, loadingNotes: false });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({ loadingNotes: false });
                }
            });
    }

    addNote() {
        const { newNote, newNoteType, record } = this.state;
        if (!newNote.trim()) return;
        const customerId = record.id || this.getCurrentFormId();
        this.httpPost('api/v1/customernote/save', {
            customerId,
            content: newNote,
            noteType: newNoteType
        }).then(data => {
            if (data.status === 1) {
                this.showSuccessMessage('یادداشت ثبت شد');
                this.setState({ newNote: '', newNoteType: 1 }, () => this.loadNotes(customerId));
            } else {
                this.showErorrMessage(data.message);
            }
        });
    }

    removeNote(id) {
        if (!window.confirm('آیا مطمئن هستید؟')) return;
        this.httpPost('api/v1/customernote/remove', { id })
            .then(data => {
                if (data.status === 1) {
                    this.showSuccessMessage('یادداشت حذف شد');
                    this.loadNotes();
                } else {
                    this.showErorrMessage(data.message);
                }
            });
    }

    renderForm() {
        const { record, users, notes, activeTab, newNote, newNoteType, loadingNotes } = this.state;
        const isEdit = record.id > 0;
        const currentUserRole = this.state.data?.global?.user?.role;
        const canIssueOrder = currentUserRole === 1 || currentUserRole === 2;
        return (
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">
                                {isEdit ? `ویرایش مشتری: ${record.name}` : 'افزودن مشتری جدید'}
                            </h3>
                            <div className="nk-block-des text-soft">
                                <p>اطلاعات مشتری را وارد نمایید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/customers/" className="btn btn-dim btn-outline-light">
                                <em className="icon ni ni-arrow-left"></em><span>بازگشت</span>
                            </NavLink>
                        </div>
                    </div>
                </div>

                <div className="nk-block">
                    <div className="card card-bordered">
                        <div className="card-inner">
                    
                            {isEdit && (
                                <ul className="nav nav-tabs">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'info' ? 'active' : ''}`}
                                            onClick={() => this.setState({ activeTab: 'info' })}>
                                            اطلاعات مشتری
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeTab === 'notes' ? 'active' : ''}`}
                                            onClick={() => {
                                                const canIssue = this.state.data?.global?.user?.role === 1 || this.state.data?.global?.user?.role === 2;
                                                this.setState({
                                                    activeTab: 'notes',
                                                    newNoteType: (!canIssue && this.state.newNoteType === 2) ? 1 : this.state.newNoteType
                                                });
                                                this.loadNotes();
                                            }}>
                                            یادداشت‌ها / مکاتبات ({notes.length})
                                        </a>
                                    </li>
                                </ul>
                            )}

                            <div className="mt-3">
                                {activeTab === 'info' && (
                                    <form onSubmit={e => this.save(e)}>
                                        <div className="row g-4">
                            
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">نوع مشتری <span className="text-danger">*</span></label>
                                                    <select className="form-select"
                                                        value={record.type}
                                                        onChange={e => this.handleChange('type', parseInt(e.target.value))}>
                                                        <option value="1">حقیقی</option>
                                                        <option value="2">حقوقی</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">وضعیت همکاری <span className="text-danger">*</span></label>
                                                    <select className="form-select"
                                                        value={record.status}
                                                        onChange={e => this.handleChange('status', parseInt(e.target.value))}>
                                                        <option value="1">فعال</option>
                                                        <option value="2">تعلیق</option>
                                                        <option value="3">خاتمه همکاری</option>
                                                    </select>
                                                </div>
                                            </div>

                             
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">
                                                        {record.type === 1 ? 'نام و نام خانوادگی' : 'نام شرکت'} <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text" className="form-control"
                                                        value={record.name}
                                                        onChange={e => this.handleChange('name', e.target.value)}
                                                        placeholder={record.type === 1 ? 'نام و نام خانوادگی' : 'نام شرکت'} />
                                                </div>
                                            </div>

                                        
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">
                                                        {record.type === 1 ? 'کد ملی' : 'شناسه ملی'} <span className="text-danger">*</span>
                                                    </label>
                                                    <input type="text" className="form-control"
                                                        value={record.nationalId}
                                                        onChange={e => this.handleChange('nationalId', e.target.value)}
                                                        placeholder={record.type === 1 ? 'کد ملی' : 'شناسه ملی'} />
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">کد اقتصادی</label>
                                                    <input type="text" className="form-control"
                                                        value={record.economicCode}
                                                        onChange={e => this.handleChange('economicCode', e.target.value)}
                                                        placeholder="کد اقتصادی" />
                                                </div>
                                            </div>

                     
                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">شماره تماس</label>
                                                    <input type="text" className="form-control"
                                                        value={record.phone}
                                                        onChange={e => this.handleChange('phone', e.target.value)}
                                                        placeholder="شماره تماس" />
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-group">
                                                    <label className="form-label">آدرس</label>
                                                    <textarea className="form-control" rows="3"
                                                        value={record.address}
                                                        onChange={e => this.handleChange('address', e.target.value)}
                                                        placeholder="آدرس" />
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">مدیر پرونده</label>
                                                    <select className="form-select"
                                                        value={record.managerUserId || ''}
                                                        onChange={e => this.handleChange('managerUserId', e.target.value ? parseInt(e.target.value) : null)}>
                                                        <option value="">-- انتخاب مدیر --</option>
                                                        {users.map(u => (
                                                            <option key={u.id} value={u.id}>{u.fullName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-lg-6">
                                                <div className="form-group">
                                                    <label className="form-label">سرپرست پرونده</label>
                                                    <select className="form-select"
                                                        value={record.supervisorUserId || ''}
                                                        onChange={e => this.handleChange('supervisorUserId', e.target.value ? parseInt(e.target.value) : null)}>
                                                        <option value="">-- انتخاب سرپرست --</option>
                                                        {users.map(u => (
                                                            <option key={u.id} value={u.id}>{u.fullName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                      
                                            <div className="col-12">
                                                <div className="form-group mt-3">
                                                    <button type="submit" className="btn btn-primary" disabled={this.state.lockScreen === 1}>
                                                        {this.state.lockScreen === 1 && <span className="spinner-border spinner-border-sm mr-2"></span>}
                                                        <em className="icon ni ni-save"></em>
                                                        <span> ذخیره اطلاعات</span>
                                                    </button>
                                                    <NavLink to="/customers/" className="btn btn-dim btn-outline-light ms-2">
                                                        <em className="icon ni ni-cross"></em><span> انصراف</span>
                                                    </NavLink>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                )}

                                {activeTab === 'notes' && (
                                    <div>
                                        <div className="mb-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                            {loadingNotes ? this.renderLoading() : (
                                                notes.length === 0 ? (
                                                    <p className="text-muted">هیچ یادداشتی ثبت نشده است.</p>
                                                ) : (
                                                    notes.map(n => (
                                                        <div key={n.id} className={`alert ${n.noteType === 2 ? 'alert-warning' : n.noteType === 3 ? 'alert-info' : 'alert-light'} mb-2`}>
                                                            <div className="d-flex justify-content-between">
                                                                <strong>{n.createdByName}</strong>
                                                                <small>{n.createdDatePersian}</small>
                                                            </div>
                                                            <span className={`badge ${n.noteType === 2 ? 'badge-warning' : n.noteType === 3 ? 'badge-info' : 'badge-secondary'}`}>
                                                                {n.noteTypeString}
                                                            </span>
                                                            <p className="mt-1">{n.content}</p>
                                                            <button className="btn btn-xs btn-danger" onClick={() => this.removeNote(n.id)}>حذف</button>
                                                        </div>
                                                    ))
                                                )
                                            )}
                                        </div>
                                        <div className="card card-bordered p-3">
                                            <div className="row g-3">
                                                <div className="col-md-3">
                                                    <select className="form-select" value={newNoteType}
                                                        onChange={e => this.setState({ newNoteType: parseInt(e.target.value) })}>
                                                        <option value="1">یادداشت</option>
                                                        {canIssueOrder && <option value="2">دستور مدیر</option>}
                                                        <option value="3">پاسخ</option>
                                                    </select>
                                                </div>
                                                <div className="col-md-7">
                                                    <input className="form-control" value={newNote}
                                                        onChange={e => this.setState({ newNote: e.target.value })}
                                                        placeholder="متن خود را بنویسید..." />
                                                </div>
                                                <div className="col-md-2">
                                                    <button className="btn btn-primary" onClick={() => this.addNote()}>ثبت</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={{ global: this.state.data?.global }} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}